import { EditOutlined } from "@ant-design/icons";
import {
  ModalForm,
  ProFormGroup,
  ProFormCheckbox,
  ProForm,
  ProFormText,
} from "@ant-design/pro-components";
import { Button, Card } from "antd";
import { useState } from "react";
import { updateCompany } from "../utils/fetch";

const CompanyFullInfo = ({ company }) => {
  const [isLoading, setIsLoading] = useState(false);
  const checkboxGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 12,
  };

  return (
    <ModalForm
      initialValues={{
        KP: false,
        act: false,
        agreement: false,
        changeState: false,
        changeStatus: false,
        clients: false,
        createLead: false,
        name: company?.name || "",
        payment: false,
        production: false,
        products: false,
        specification: false,
        assemblyStatus: false,
        manufactureStatus: false,
        ProFormCheckbox: false,
        installationStatus: false,
        distribution: false,
        viewAllFinances: false,
        ...company.permission,
      }}
      onFinish={(values) => {
        setIsLoading(true);

        const { name } = values;
        delete values.name;

        updateCompany({
          companyId: company._id,
          body: {
            name,
            permission: values,
          },
          setIsLoading,
        });
      }}
      title={company?.name || "Редактировать"}
      trigger={
        <Button
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: 5,
            padding: 5,
          }}
          size="large"
        >
          <EditOutlined />
        </Button>
      }
      submitter={{
        submitButtonProps: {
          loading: isLoading,
        },
      }}
      modalProps={{
        width: 960,
        bodyStyle: { padding: 24 },
      }}
    >
      <ProFormGroup>
        <ProFormText name="name" label="Название" />
      </ProFormGroup>
      <Card>
        <ProForm.Group>
          <div style={checkboxGridStyle}>
            <ProFormCheckbox name="createLead">Создание заявки</ProFormCheckbox>
            <ProFormCheckbox name="clients">Доступ к клиентам</ProFormCheckbox>
            <ProFormCheckbox name="distribution">
              Распределение
            </ProFormCheckbox>
            <ProFormCheckbox name="keplerRob">Kepler Sales Hub (доступ)</ProFormCheckbox>
            <ProFormCheckbox name="keplerRobAdmin">Kepler Sales Hub (админ)</ProFormCheckbox>
            <ProFormCheckbox name="viewAllFinances">Просмотр всех финансов</ProFormCheckbox>
          </div>
        </ProForm.Group>
        <ProForm.Group>
          <div style={checkboxGridStyle}>
            <ProFormCheckbox name="specification">Спецификация</ProFormCheckbox>
            <ProFormCheckbox name="act">Заявка на производство</ProFormCheckbox>
            <ProFormCheckbox name="agreement">Договор</ProFormCheckbox>
            <ProFormCheckbox name="KP">КП</ProFormCheckbox>
            <ProFormCheckbox name="payment">Счет на оплату</ProFormCheckbox>
          </div>
        </ProForm.Group>
        <ProForm.Group>
          <div style={checkboxGridStyle}>
            <ProFormCheckbox name="products">Товары</ProFormCheckbox>
            <ProFormCheckbox name="orderStatus">Статусы заказов</ProFormCheckbox>
            <ProFormCheckbox name="production">Запуск на производство</ProFormCheckbox>
            <ProFormCheckbox name="changeStatus">Изменение статуса</ProFormCheckbox>
          </div>
        </ProForm.Group>
        <ProForm.Group>
          <div style={checkboxGridStyle}>
            <ProFormCheckbox name="changeState">
              Принятие / отклонение заявок
            </ProFormCheckbox>
            <ProFormCheckbox name="assemblyStatus">
              Статусы сборки
            </ProFormCheckbox>
            <ProFormCheckbox name="manufactureStatus">
              Статусы производства
            </ProFormCheckbox>
            <ProFormCheckbox name="deliveryStatus">
              Статусы доставки
            </ProFormCheckbox>
            <ProFormCheckbox name="installationStatus">
              Статусы монтажа
            </ProFormCheckbox>
          </div>
        </ProForm.Group>
      </Card>
    </ModalForm>
  );
};

export default CompanyFullInfo;
